import React, { useState, useEffect } from 'react';
import { getUsers, createUser, updateUser, deleteUser } from '../api/leadsApi';

export default function AdminPage() {
  const [users, setUsers] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', password: '' });
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');

  const fetch = async () => { try { const r = await getUsers(); setUsers(r.data); } catch(e) {} };
  useEffect(() => { fetch(); }, []);

  const flash = (m) => { setMsg(m); setTimeout(() => setMsg(''), 2500); };

  const handleCreate = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.password) { setError('All fields required'); return; }
    setSaving(true); setError('');
    try { await createUser(form); setForm({ name: '', email: '', password: '' }); setShowForm(false); fetch(); flash('User created successfully'); }
    catch(e) { setError(e.response?.data?.message || 'Failed to create user'); }
    setSaving(false);
  };

  const toggleActive = async (user) => {
    try { await updateUser(user._id, { isActive: !user.isActive }); fetch(); flash(`User ${user.isActive ? 'deactivated' : 'activated'}`); }
    catch(e) {}
  };

  const removeUser = async (id) => {
    if (!window.confirm('Remove this user?')) return;
    try { await deleteUser(id); fetch(); flash('User removed'); } catch(e) {}
  };

  return (
    <div style={s.page}>
      <div style={s.header}>
        <div>
          <h1 style={s.title}>Team management</h1>
          <p style={s.sub}>Create and manage team members who can access the leads funnel</p>
        </div>
        <button style={s.addBtn} onClick={() => setShowForm(f => !f)}>{showForm ? 'Cancel' : '+ Add team member'}</button>
      </div>

      {msg && <div style={s.flash}>{msg}</div>}

      {showForm && (
        <div style={s.formCard}>
          <h3 style={s.formTitle}>New team member</h3>
          <form onSubmit={handleCreate} style={s.form}>
            <input style={s.input} placeholder="Full name" value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} />
            <input style={s.input} type="email" placeholder="Email address" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} />
            <input style={s.input} type="password" placeholder="Temporary password (min 8 chars)" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} />
            {error && <div style={s.error}>{error}</div>}
            <button style={s.submitBtn} type="submit" disabled={saving}>{saving ? 'Creating...' : 'Create account'}</button>
          </form>
        </div>
      )}

      <div style={s.table}>
        <div style={s.tableHeader}>
          <span>Name</span><span>Email</span><span>Role</span><span>Status</span><span>Last login</span><span>Actions</span>
        </div>
        {users.map(u => (
          <div key={u._id} style={{ ...s.tableRow, opacity: u.isActive ? 1 : 0.5 }}>
            <span style={s.userName}>{u.name}</span>
            <span style={s.cell}>{u.email}</span>
            <span><span style={{ ...s.badge, background: u.role === 'super_admin' ? '#EEEDFE' : '#E1F5EE', color: u.role === 'super_admin' ? '#534AB7' : '#0F6E56' }}>{u.role === 'super_admin' ? 'Super admin' : 'Team member'}</span></span>
            <span><span style={{ ...s.badge, background: u.isActive ? '#E1F5EE' : '#FCEBEB', color: u.isActive ? '#0F6E56' : '#A32D2D' }}>{u.isActive ? 'Active' : 'Inactive'}</span></span>
            <span style={s.cell}>{u.lastLogin ? new Date(u.lastLogin).toLocaleDateString() : 'Never'}</span>
            <span style={s.actions}>
              {u.role !== 'super_admin' && (
                <>
                  <button style={s.actionBtn} onClick={() => toggleActive(u)}>{u.isActive ? 'Deactivate' : 'Activate'}</button>
                  <button style={{ ...s.actionBtn, color: '#A32D2D', borderColor: '#A32D2D' }} onClick={() => removeUser(u._id)}>Remove</button>
                </>
              )}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

const s = {
  page: { padding: '1.5rem', fontFamily: 'Inter, system-ui, sans-serif', maxWidth: 900, margin: '0 auto' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 },
  title: { fontSize: 20, fontWeight: 600, margin: 0, color: '#1a1a1a' },
  sub: { fontSize: 13, color: '#888', marginTop: 4 },
  addBtn: { background: '#534AB7', color: '#fff', border: 'none', borderRadius: 8, padding: '9px 16px', fontSize: 13, fontWeight: 500, cursor: 'pointer' },
  flash: { background: '#E1F5EE', color: '#0F6E56', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 16, fontWeight: 500 },
  formCard: { background: '#fff', border: '1px solid #e0e0e0', borderRadius: 12, padding: '20px', marginBottom: 20, boxShadow: '0 1px 4px rgba(0,0,0,0.06)' },
  formTitle: { fontSize: 14, fontWeight: 600, margin: '0 0 14px', color: '#1a1a1a' },
  form: { display: 'flex', flexDirection: 'column', gap: 10 },
  input: { padding: '9px 12px', borderRadius: 8, border: '1px solid #e0e0e0', fontSize: 13, outline: 'none', color: '#1a1a1a' },
  error: { background: '#fff0f0', color: '#c0392b', padding: '8px 12px', borderRadius: 8, fontSize: 13 },
  submitBtn: { padding: '9px 18px', background: '#534AB7', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 500, cursor: 'pointer', alignSelf: 'flex-start' },
  table: { background: '#fff', border: '1px solid #e0e0e0', borderRadius: 12, overflow: 'hidden' },
  tableHeader: { display: 'grid', gridTemplateColumns: '1.5fr 2fr 1fr 1fr 1fr 1.5fr', padding: '10px 16px', background: '#f5f4f0', fontSize: 11, fontWeight: 600, color: '#888', textTransform: 'uppercase', letterSpacing: '0.04em', gap: 8 },
  tableRow: { display: 'grid', gridTemplateColumns: '1.5fr 2fr 1fr 1fr 1fr 1.5fr', padding: '12px 16px', borderTop: '1px solid #f0efe9', alignItems: 'center', gap: 8 },
  userName: { fontSize: 13, fontWeight: 600, color: '#1a1a1a' },
  cell: { fontSize: 13, color: '#555' },
  badge: { fontSize: 11, padding: '3px 10px', borderRadius: 10, fontWeight: 500 },
  actions: { display: 'flex', gap: 6 },
  actionBtn: { fontSize: 11, padding: '4px 10px', borderRadius: 6, border: '1px solid #e0e0e0', background: '#fff', color: '#555', cursor: 'pointer' },
};
